import { defineMessages } from 'react-intl'

const translations = defineMessages({
  goBack: {
    defaultMessage: 'Go back to My Orders',
    id: 'msp.account.order_history.go_back'
  },
  myOrder: {
    defaultMessage: 'My Order: #{orderNo}',
    id: 'msp.account.order_history.my_order'
  }
})

export default translations
